import './App.css';
import Home from './Home';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Details from './components/products/Details';
import Header from './components/Header';
import Bottom from './components/Bottomnav';
import Footer from './components/Footer';
import Products from './components/products/Products';
import Cart from './components/products/Cart';
import { useEffect, useState } from 'react';



function App() {

  const [cart, setCart]= useState([])

  const handleClick = (item) =>{
    // console.log("cart content",item);
    // cart.push(item);
    // console.log(cart);
    // console.log(cart.length);
    if(cart.indexOf(item) !== -1) return;
    setCart([...cart, item]);
  };

  // const handleChange = (item, d) =>{
  //   const ind = cart.indexOf(item);
  //   const arr = cart;
  //   arr[ind].amount += d;

  //   if(arr[ind].amount === 0) arr[ind].amount = 1;
  //   setCart([...arr]);
  // };

  // useEffect(() => {
  //   console.log("cart change");
  // }, [cart]);

  
  return (
   <>
      
      <Router>
      <Header size={cart.length} />
        <Routes>
          <Route  path='/' element={<Home handleClick={handleClick}/>} />
          <Route path='/productdetails/:id/:model' element={<Details/>} />
          <Route path='/cart' element={<Cart  setCart={setCart} cart={cart}/>} />

        </Routes>
        
        <Bottom size={cart.length}/>
      </Router>

  
   </>
    
  );
}

export default App;
